module.exports = __webpack_public_path__ + "media/images/logo_dark-90598236f8ce748033ce3651bbcac9ea.svg";